import React from 'react';
import api from '../api/api';
import util from '../util/util';
import TinyMCE from 'react-tinymce';

class MessageModal extends React.Component {
    constructor(props){
        super(props);
        
		this.state = {
			messageID: util.IsDefined(this.props.messageData) ? this.props.messageData.MESSAGEID : 0,
			sender: util.IsDefined(this.props.box) && this.props.box === 'inbox' ? this.props.messageData.SENDER : util.IsDefined(this.props.messageData) ? this.props.messageData.RECIPIENT : '',
			messageText:  util.IsDefined(this.props.messageData) ? this.props.messageData.BODY : '',
			messageDate:  util.IsDefined(this.props.messageData) ? this.props.messageData.SENDDATE : '',
			box: util.IsDefined(this.props.box) ? this.props.box : 'inbox'
		}
        
    }
    
	componentWillMount() {
		let body = this.state.messageText !== '' ? '<p></p><p></p><hr /><p><strong>Message From: </strong>' + this.state.sender + '<br/><strong>Sent On: </strong>' + this.state.messageDate + '</p>' + this.state.messageText : '';
		this.setState({
			messageText: body
		})
	}
	
    componentDidMount(){
		if(util.isMobile.any() && window.innerWidth < 500) {
			let windowHeight = window.innerHeight;
			$('.msgContainer').css({
				height: windowHeight - 85
			})
		}
    }
    
	replyToMessage(){
		this.setState({
			messageID: 0
		})
	}
	
    sendMessage(){
		if(this.refs.MessageModal.props.content.length <= 2)
			return false;
		let data = {
			method: 'AddMessage',
			MessageType: 'Message', 
			Body: this.refs.MessageModal.props.content, 
			SenderAccountID: accountID, 
			RecipientAccountID: this.props.ReceiverID
		}

		api.StoreService(data).end((err, res) => {
			let result = JSON.parse(res.text);
			if(typeof result.MessageID !== 'undefined'){
				var message = firstName + ' ' + lastName + ' sent you a message <br /> <a href="/myAccount/#secmessages">Go To Inbox</a>.';
				/*publish(message, 'message', this.props.ReceiverID);*/
			}
			this.closeModal();
		});
    }
    
	handleTextBlur(e) {
		if(!e.target.isNotDirty) {
			this.setState({
				messageText: e.target.getContent()
			})
		}
	}
	
    closeModal(){
        this.props.closeModal()
    }
    
    render(){
		let displayMessage = {display: this.state.messageID !== 0 ? 'block' : 'none', padding: 15, overflow: 'auto'};
		let displayReceivedMessage = {display: this.state.messageID !== 0 ? 'block' : 'none', padding: 0, overflow: 'auto'};
		let displayReceivedClose = {display: this.state.messageID !== 0 ? 'inline-block' : 'none', float: 'right'};
		let displaySendClose = {display: this.state.messageID !== 0 ? 'none' : 'inline-block', float: 'right'};
		let headerTitle = this.state.box === 'inbox' ? 'Message From: ' : 'Sent To: ';
		let displayReplyMessage = {display: this.state.messageID !== 0 && this.state.box === 'inbox' ? 'inline-block' : 'none', position: 'absolute', bottom: 0, left: 0, backgroundColor: "#FFF"};
		let displaySendMessage = {display: this.state.messageID === 0 ? 'block' : 'none'};
		let displaySendMessageBTN = {display: this.state.messageID === 0 ? 'block' : 'none', position: 'absolute', bottom: 0, left: 0};
		
		
        return(
            <div className="messagingModal clearfix">
				<h1 className="title padded grey clearfix" style={displayMessage}>
                    {headerTitle} {this.state.sender} <i className="glyphicon glyphicon-remove floatRight" style={displayReceivedClose} onClick={this.props.closeModal.bind(this)}></i>
                </h1>
				<div className="col-12 clearfix msgContainer" style={displayReceivedMessage}>
					<div dangerouslySetInnerHTML={{__html: this.state.messageText}} style={{height: 306, overflow: 'auto', padding: 15}}></div>
				</div>
				<div className="col-12 clearfix" style={displayReplyMessage}>
                    <button type="button" onClick={this.replyToMessage.bind(this)} className="btn btn-blue">Reply</button>
                </div>
					
					
                <h1 className="title padded grey clearfix" style={displaySendMessage}>
                    Sending to: {this.props.Name} <i className="glyphicon glyphicon-remove floatRight" style={displaySendClose} onClick={this.closeModal.bind(this)}></i>
                </h1>
                <div className="col-12 clearfix msgContainer" style={displaySendMessage}>
					<TinyMCE 
						content={this.state.messageText} 
						config={{
							menubar:false,
							statusbar: false,
							theme: "modern",
							editor_selector : "my_tinymce",
							height: 320,
							placeholder: "Compose your Message",
							content_css: '/styles/editor.css',
							toolbar: "styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist",
							plugins: "paste",
							paste_as_text: true
						}}
						ref="MessageModal"
						onBlur={this.handleTextBlur.bind(this)}
					/>
                </div>
                <div className="col-12 clearfix" style={displaySendMessageBTN}>
                    <button type="button" onClick={this.sendMessage.bind(this)} className="btn btn-blue">Send</button>
                </div>
            </div>
        )
    }
}

MessageModal.defaultProps = {
	Name: 'No Name'
}

MessageModal.propTypes = {
    closeModal: React.PropTypes.func.isRequired,
    Name: React.PropTypes.string.isRequired,
    ReceiverID: React.PropTypes.number.isRequired
}

export default MessageModal;


/** WEBPACK FOOTER **
 ** ./app/reusable/messaging-modal.js
 **/